import {createContext} from "react";

import {noop} from "@pg-mono/nodash";

import {IInteractiveRegion} from "../types/IInteractiveRegion";
import {IInteractiveRegionInput} from "../types/IInteractiveRegionInput";

export type InteractiveRegionsMapContextValue = {
    updateRegionsImmediately?: boolean;
    showMainRegionMapOutline?: boolean;
    isInModal?: boolean;
    tracking?: {
        onMapInit: (params: {regionName: string}) => void;
        onMapUpdate: (params: {regionName: string}) => void;
        onRegionCheckboxToggle: (params: {regionName: string; selectionName: string; action: "on" | "off"}) => void;
    };
    getMainRegion: (parentId: number) => Promise<IInteractiveRegion | null>;
    getDistrictsAndSurroundings: (parentId: number) => Promise<IInteractiveRegion[] | null>;
    selectedRegions: IInteractiveRegionInput[] | null;
    handleUpdateRegions: (selectedRegions: IInteractiveRegion[], parentRegion: {id: number; name: string; slug: string} | null) => void;
    remoteStateSync?: {
        temporaryRegionSelectionState: (string | number)[] | null;
        originRegionSelectionState: (string | number)[] | null;
        syncTemporaryRegionSelection: (selectedRegionIds: (string | number)[]) => void;
        applyRegionSelection: (selectedRegions: (string | number)[]) => void;
    };
};

export const InteractiveRegionsMapContext = createContext<InteractiveRegionsMapContextValue>({
    getMainRegion: () => Promise.resolve(null),
    getDistrictsAndSurroundings: () => Promise.resolve(null),
    selectedRegions: null,
    handleUpdateRegions: noop
});
import {createContext} from "react";

import {noop} from "@pg-mono/nodash";

import {IInteractiveRegion} from "../types/IInteractiveRegion";
import {IInteractiveRegionInput} from "../types/IInteractiveRegionInput";

export type InteractiveRegionsMapContextValue = {
    updateRegionsImmediately?: boolean;
    showMainRegionMapOutline?: boolean;
    isInModal?: boolean;
    tracking?: {
        onMapInit: (params: {regionName: string}) => void;
        onMapUpdate: (params: {regionName: string}) => void;
        onRegionCheckboxToggle: (params: {regionName: string; selectionName: string; action: "on" | "off"}) => void;
    };
    getMainRegion: (parentId: number) => Promise<IInteractiveRegion | null>;
    getDistrictsAndSurroundings: (parentId: number) => Promise<IInteractiveRegion[] | null>;
    selectedRegions: IInteractiveRegionInput[] | null;
    handleUpdateRegions: (selectedRegions: IInteractiveRegion[], parentRegion: {id: number; name: string; slug: string} | null) => void;
    remoteStateSync?: {
        temporaryRegionSelectionState: (string | number)[] | null;
        originRegionSelectionState: (string | number)[] | null;
        syncTemporaryRegionSelection: (selectedRegionIds: (string | number)[]) => void;
        applyRegionSelection: (selectedRegions: (string | number)[]) => void;
    };
};

export const InteractiveRegionsMapContext = createContext<InteractiveRegionsMapContextValue>({
    getMainRegion: () => Promise.resolve(null),
    getDistrictsAndSurroundings: () => Promise.resolve(null),
    selectedRegions: null,
    handleUpdateRegions: noop
});
